// extracted by mini-css-extract-plugin
export default {"root":"_2Ln82","content":"W2TqI"};